$(document).ready(function () {
  var $carousel = $(".cs-blog-slider");
  var settings = {
    dots: false,
    arrows: true,
    slide: ".cs-main-article",
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "60px",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
  function setSlideVisibility() {
    var visibleSlides = $carousel.find(".cs-main-article");
    $(visibleSlides).each(function () {
      $(this).css("opacity", 1);
    });
    $(visibleSlides).first().prev().css("opacity", 0);
  }

  $carousel.slick(settings);
  $carousel.slick("slickGoTo", 1);
  setSlideVisibility();

  $carousel.on("afterChange", function () {
    setSlideVisibility();
  });
});

$(document).ready(function () {
  var $carousel = $(".main-teestinmonial-slide");
  var settings = {
    dots: false,
    arrows: true,
    slide: ".cs-customer-testimonials",
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "60px",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
  function setSlideVisibility() {
    var visibleSlides = $carousel.find(".cs-customer-testimonials");
    $(visibleSlides).each(function () {
      $(this).css("opacity", 1);
    });
    $(visibleSlides).first().prev().css("opacity", 0);
  }

  $carousel.slick(settings);
  $carousel.slick("slickGoTo", 1);
  setSlideVisibility();

  $carousel.on("afterChange", function () {
    setSlideVisibility();
  });
});

$(document).ready(function () {
  $(".accordion-button").click(function () {
    var panel = $(this).next(".accordion-panel");
    if (panel.is(":visible")) {
      panel.slideUp();
      $(this).removeClass("active");
    } else {
      $(".accordion-panel").slideUp();
      panel.slideDown();
      $(".accordion-button").removeClass("active");
      $(this).addClass("active");
    }
  });
});

$(document).ready(function () {
  $(".facet-filters__label").click(function () {
    $(this).find(".icon").toggleClass("icon-rotated");
    $(this).siblings(".facet-filters__sort").toggle();
  });
});

// Collection Read More Button
$(document).ready(function(){
    var fullText = $('#collectionDescription').html();
    var wordCount = fullText.split(' ').length;
    
    // Check if there's enough text to show the "Read More" button
    if (wordCount > 50) {
        var description = $('<div>').html(fullText).text().split(' ').slice(0, 50).join(' ');
        $('#collectionDescription').html(description + '...');
        $('#readMore').show(); // Show the "Read More" button
    } else {
        $('#collectionDescription').html(fullText); // Show full text
        $('#readMore').hide(); // Hide the "Read More" button
    }
    
    $('#readMore').click(function(e){
        e.preventDefault();
        var $this = $(this);
        if ($this.text() === 'Read More') {
            $('#collectionDescription').html(fullText);
            $this.text('Read Less');
        } else {
            var shortText = $('<div>').html(fullText).text().split(' ').slice(0, 50).join(' ');
            $('#collectionDescription').html(shortText + '...');
            $this.text('Read More');
        }
    });
});




//PDP in stock/out stock text //
document.addEventListener("DOMContentLoaded", function () {
  const selectElements = document.querySelectorAll(".variants-selector");
  const availabilityMessages = document.querySelectorAll(
    ".availability-message"
  );
  selectElements.forEach((selectElement, index) => {
    const availabilityMessage = availabilityMessages[index];
    selectElement.addEventListener("change", function () {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      if (selectedOption.classList.contains("var-in")) {
        availabilityMessage.textContent = "In stock";
      } else if (selectedOption.classList.contains("var-out")) {
        availabilityMessage.textContent = "Out of stock";
      }
    });
    // Initial check on page load
    const initialSelectedOption =
      selectElement.options[selectElement.selectedIndex];
    if (initialSelectedOption.classList.contains("var-in")) {
      availabilityMessage.textContent = "In stock";
    } else if (initialSelectedOption.classList.contains("var-out")) {
      availabilityMessage.textContent = "Out of stock";
    }
  });
});
//Header cart account append //
$(document).ready(function () {
  // Function to append content to new divs
  function appendContent() {
    // Check if window width is greater than or equal to 1200px
    if ($(window).width() >= 1200) {
      // Append content of .header__icon--account to .acc-ann
      $(".acc-ann").html($(".header__icon--account"));

      // Append content of .header__icon--cart to .cart-ann
      $(".cart-ann").html($(".header__icon--cart"));
    } else {
      // If width is less than 1200px, clear the content
      $(".acc-ann, .cart-ann").html("");
    }
  }

  // Call the function on document ready and window resize (for responsiveness)
  appendContent();
  $(window).resize(appendContent);
});

$(document).ready(function () {
  // By default, filters are closed
  $(".facets__filters-label-main").on("click", function () {
    $(".facets-vertical-main-head").toggleClass("filters-open"); // Toggle filters-open class
    $(this).text(function (i, text) {
      return text === "Show Filters" ? "Hide Filters" : "Show Filters"; // Toggle text
    });
  });
});

// $(document).ready(function () {
//   const productsPerPage = 12;
//   const productsToShow = 4;
//   const $productGrid = $(".product-grid");
//   const $products = $productGrid.find(".grid__item");
//   let visibleProducts = productsPerPage;

//   // Hide products after the initial visible products
//   $products.slice(visibleProducts).hide();

//   // Show more products on button click
//   $("#load-more-btn").on("click", function () {
//     const currentlyVisible = $products.filter(":visible").length;
//     const nextVisible = currentlyVisible + productsToShow;

//     $products.slice(currentlyVisible, nextVisible).fadeIn();

//     if (nextVisible >= $products.length) {
//       $("#load-more-btn").hide();
//     }
//   }); 
// });

//Home blog articles slider //
$(document).ready(function () {
  $(".slick-list-blogs").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    // arrows: true,
    infinite: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".prev-btn").click(function () {
    $(".slick-list-blogs").slick("slickPrev");
  });

  $(".next-btn").click(function () {
    $(".slick-list-blogs").slick("slickNext");
  });
  $(".prev-btn").addClass("slick-disabled");
  $(".slick-list-blogs").on("afterChange", function () {
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn").addClass("slick-disabled");
    } else {
      $(".prev-btn").removeClass("slick-disabled");
    }
    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btn").addClass("slick-disabled");
    } else {
      $(".next-btn").removeClass("slick-disabled");
    }
  });
});

// Header menu open on hover
let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
console.log(items);
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

// $(window).on('load resize', function () {
//   changepos();
// });

// function changepos() {
//   var subwidth = $('.header__inline-menu .list-menu').width();
//   var subspaceleft = $('.header .header__heading').width();
//   $('.mega-menu__content .mega-menu__list').css('width', subwidth  + 'px');
//   $('.mega-menu__content .mega-menu__list').css('marginLeft', subspaceleft + 'px');
// }

// Testimonial Jquery Code
document.addEventListener("DOMContentLoaded", function () {
  function getRandomDateWithinLastTwoWeeksOfYear() {
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var startOfYear = new Date(currentYear, 0, 1); // January 1st of the current year
    var endOfYear = new Date(currentYear, 11, 31); // December 31st of the current year
    var randomDays = Math.floor(Math.random() * 14); // Random days within the last two weeks
    var twoWeeksAgo = new Date(
      currentDate.getTime() - randomDays * 24 * 60 * 60 * 1000
    );

    // Ensure the generated date is within the current year
    if (twoWeeksAgo < startOfYear) {
      twoWeeksAgo = startOfYear;
    } else if (twoWeeksAgo > endOfYear) {
      twoWeeksAgo = endOfYear;
    }

    // Define month names
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Get month, day, and year
    var month = monthNames[twoWeeksAgo.getMonth()];
    var day = twoWeeksAgo.getDate();
    var year = twoWeeksAgo.getFullYear();

    // Add appropriate suffix to day
    var daySuffix;
    switch (day) {
      case 1:
      case 21:
      case 31:
        daySuffix = "st";
        break;
      case 2:
      case 22:
        daySuffix = "nd";
        break;
      case 3:
      case 23:
        daySuffix = "rd";
        break;
      default:
        daySuffix = "th";
    }

    // Format the date
    var formattedDate = month + " " + day + daySuffix + ", " + year;
    return formattedDate;
  }

  // Update the date for each testimonial block
  var placeholders = document.querySelectorAll(".testimonial-date-placeholder");
  placeholders.forEach(function (element) {
    element.textContent = getRandomDateWithinLastTwoWeeksOfYear();
  });
});


$(document).ready(function() {
$('.cs-file-custom input[type="file"]').on('click', function() {
    $(".file_names").html("");
  })
if ($('.cs-file-custom input[type="file"]')[0]) {
	var fileInput = document.querySelector('label[for="cs-file-uploader"]');
	fileInput.ondragover = function() {
		this.className = "cs-file-label changed";
		return false;
	}
	fileInput.ondragleave = function() {
		this.className = "cs-file-label";
		return false;
	}
	fileInput.ondrop = function(e) {
		e.preventDefault();
		var fileNames = e.dataTransfer.files;
		for (var x = 0; x < fileNames.length; x++) {
			console.log(fileNames[x].name);
			$=jQuery.noConflict();
			$('label[for="cs-file-uploader"]').append("<div class='file_names'>"+ fileNames[x].name +"</div>");
		}
	}
	$('#cs-file-uploader').change(function() {
		var fileNames = $('#cs-file-uploader')[0].files[0].name;
		$('label[for="cs-file-uploader"]').append("<div class='file_names'>"+ fileNames +"</div>");
		$('label[for="cs-file-uploader"]').css('background-color', '##eee9ff');
	});
	}
});

$(document).ready(function(){
    $(".close-button, .sib-text-form-block").click(function(){
        $(".popup").hide();
    });
});





// window.REQUIRED_CODE_ERROR_MESSAGE = 'Please choose a country code';
//   window.LOCALE = 'en';
//   window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";

//   window.REQUIRED_ERROR_MESSAGE = "This field cannot be left blank. ";

//   window.GENERIC_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";

//   window.translation = {
//     common: {
//       selectedList: '{quantity} list selected',
//       selectedLists: '{quantity} lists selected'
//     }
//   };

//   var AUTOHIDE = Boolean(1);

//   // Function to hide the form after successful submission
//   function hideForm() {
//     var popup = document.getElementById('popup');
//     popup.style.display = 'none';
//   }

//   document.addEventListener('DOMContentLoaded', function() {
//     document.getElementById('sib-form').addEventListener('submit', function() {
//       hideForm();
//     });
//   });




/* Newsletter modal */
// $(document).ready(function () {
//   var cookieshowhide = $.cookie('newsletter');
//   if (cookieshowhide == 'false') {
//     $('.newsletter-modal').removeClass('is-visible');
//   } else {
//     setTimeout(function () {
//       $('.newsletter-modal').addClass('is-visible');
//     }, 5000);
//   }
//   $('.newsletter-modal-toggle').on('click', function (e) {
//     e.preventDefault();
//     $('.newsletter-modal').toggleClass('is-visible');
//     $.cookie("newsletter", 'false', { expires: 365 });
//   });
// });
// $(document).click(function(event) {
//   if (!$(event.target).closest(".newsletter-modal").length) {
//     $("body").find(".newsletter-modal").removeClass("is-visible");
//   }
// });
$(document).ready(function () {
  var isFirstVisit = $.cookie('isFirstVisit');
  var formSubmitted = localStorage.getItem('formSubmitted');

  // Function to show the coupon icon
  function showCouponIcon() {
    $('.coupon-icon').show();
  }

  // Function to hide the coupon icon
  function hideCouponIcon() {
    $('.coupon-icon').hide();
  }

  // Function to handle form submission
  function handleFormSubmission() {
    hideCouponIcon();
    localStorage.setItem('formSubmitted', 'true');
  }

  // Initially hide the coupon icon
  hideCouponIcon();

  // Show the popup on the first visit
  if (!isFirstVisit) {
    setTimeout(function () {
      $('.newsletter-modal').addClass('is-visible');
    }, 5000);
    $.cookie('isFirstVisit', 'true', { expires: 365 });
  } else if (formSubmitted !== 'true') {
    showCouponIcon(); // Show coupon icon on subsequent visits if form not submitted
  }

  // Toggle the newsletter modal and manage coupon icon visibility
  $('.newsletter-modal-toggle').on('click', function (e) {
    e.preventDefault();
    var $newsletterModal = $('.newsletter-modal');
    $newsletterModal.toggleClass('is-visible');
    if ($newsletterModal.hasClass('is-visible')) {
      hideCouponIcon(); // Hide coupon icon when popup is shown
    } else if (formSubmitted !== 'true') {
      showCouponIcon();
    }
  });

  // Show the modal and hide the coupon icon when the coupon icon is clicked
  $('.coupon-icon').on('click', function () {
    $('.newsletter-modal').addClass('is-visible');
    hideCouponIcon();
  });

  // Close the popup when clicking outside and show coupon icon if applicable
  $(document).on('click', function (event) {
    var $target = $(event.target);
    var $newsletterModal = $('.newsletter-modal');
    if (!$target.closest('.newsletter-modal').length && !$target.closest('.coupon-icon').length) {
      $newsletterModal.removeClass('is-visible');
      if (isFirstVisit === 'true' && formSubmitted !== 'true') {
        showCouponIcon();
      }
    }
  });

  // Handle form submission
  $('#sib-form').on('submit', function () {
    handleFormSubmission();
  });
});



/* Product page open first accordion */
 document.addEventListener("DOMContentLoaded", function() {
    var firstAccordion = document.querySelector(".cs-accordion-tabs details");
    if (firstAccordion) {
      firstAccordion.setAttribute("open", "true");
    }
  });


//collection filter
$(document).ready(function () {
  // Initially close all filters
  $(".cs-menu-link").addClass("accordion-menu-active");
  $(".menu").hide();

  // Toggle the visibility of the .cateory-menu element
  $(".acrodn-category a").click(function (e) {
    e.preventDefault();
    var productCategory = $(this).closest(".product-category");
    var categoryMenu = productCategory.find(".cateory-menu");
    categoryMenu.slideToggle();
    productCategory.toggleClass("accordion-close");
  });

  // Toggle collection filter menu
  $(".cs-menu-link").click(function (e) {
    // Check if the click was on a sub-menu item (a link inside .menu)
    if (!$(e.target).closest(".menu").length) {
      e.preventDefault();
      var menu = $(this).find(".menu");
      menu.slideToggle();
      $(this).toggleClass("accordion-menu-active");
    }
  });
});






